import Start from "../Pages/Start.vue"
import HomeView from "../Views/HomeView.vue"

const routes = [
    {
        path:'/welcome',
        component: HomeView,
        children: [
            {
              path: '',
              name: 'Welcome',
              component: Start,
              meta: {
                authRequired: true
              }
            }
        ]
    }
]

export default routes
